import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { QUARTILE } from '../../fields';
import { QUARTILE_VIDEO_REPORT_ID } from './quartileVideoReportId';

const quartileReportFooterColumnDefinition = [QUARTILE].map(createFooterMapper(QUARTILE_VIDEO_REPORT_ID));

export default quartileReportFooterColumnDefinition;
